import React from 'react';

interface ListCardProps {
    children: React.ReactNode;
}

/**
 * 列表卡片容器，用于包裹交易列表（TxTable + 筛选器/分页）。
 * 三个列表页（首页、地址详情、区块详情）共用。
 */
const ListCard: React.FC<ListCardProps> = ({ children }) => (
    <div
        style={{
            backgroundColor: 'var(--app-card-bg)',
            borderRadius: 'var(--radius-lg)',
            overflow: 'hidden',
            border: '0.5px solid var(--app-card-border)',
        }}
    >
        {children}
    </div>
);

export default ListCard;
